import React, { FC, useContext, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Select,{ GroupBase, OptionsOrGroups, PropsValue, SingleValue } from "react-select";

import FooterText from "../../components/footerText";
import AuthSubHeader from "src/components/authSubHeader";

import useFetch from "src/hooks/useFetch";

import { APIEndpoints } from "src/types/apiTypes";
import { PrecertAPIResponse } from "../precert/types";
import { AuthContext } from "src/context/authContext";

const STATE_UPDATE_PA = [
  {
    value: 'approved',
    label: 'Approved',
    change_note: 'Precert Marked Approved by office.',
  },
  {
    value: 'denied',
    label: 'Denied',
    change_note: 'Precert Marked Denied by office.',
  },
   {
    value: 'cancelled',
    label: 'Cancelled',
    change_note: 'Precert Cancelled by office.',
  }
];



const UpdatePrecert: FC = (): JSX.Element => {
  const [cancelReason, setCancelReason] = useState<string>('approved');
  const {isManufacturer}=useContext(AuthContext)

  const { caseId, precertsId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search); // Parse query params





  const { mutate: fetchPrecertMutate, data: fetchPrecertResponse } =
    useFetch<PrecertAPIResponse>(APIEndpoints.UPDATE_PRECERT, {}, {}, false);

  useEffect(() => {
    if (fetchPrecertResponse)      {
      isManufacturer ? navigate(`/todos_statistics`) : navigate(`/cases`);
    }


    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchPrecertResponse]);

  const UpdatePrecertButton = () => {
    const pathParams = {
      case_id: caseId,
      id: precertsId
    }
    const queryParams = {
      status: cancelReason,
      case_id: caseId,
      change_note: STATE_UPDATE_PA.find((item) => item.value === cancelReason)?.change_note,
    }

    fetchPrecertMutate({}, pathParams, queryParams)
  }




  const onChangeSelect = (value: SingleValue<string>) => {
    setCancelReason((value as unknown as { value: string; label: string; }).value);
  };

  const getValue = () => {
    const data = STATE_UPDATE_PA.find((option) => option.value === cancelReason);
    if (data) return data as unknown as PropsValue<string>;
  };

    return (
        <div className="overflow-y-auto overflow-x-hidden d-flex flex-column flex-fill">
            <div className="bg-mist py-2">
                <div className="container-fluid">
                    <AuthSubHeader/>
                </div>
            </div>
            <div className="container-fluid pt-2 d-flex flex-column flex-fill">
                <div className="card-header">
                    <h2 className="m-0 page-heading">
                        Update PA Status for Case {caseId}
                        <small className="fs-4">{'(' + queryParams.get('patient') + ")"}</small>
                    </h2>
                    <p className="fw-bold m-0 fs-5">(Insurance Name: {queryParams.get('insuranceName')})</p>
                    <p> if you've received updated information or wish to cancel your PA,
                        select a status from the dropdown below and the system will update this case for you.
                    </p>
                </div>
                <div className="card">
                    <div className="card-body">


                        <div className="row align-items-center">
                            <div className="col-12 col-md-10">
                                <Select
                                    options={STATE_UPDATE_PA as unknown as OptionsOrGroups<string, GroupBase<string>>}
                                    id="updatePA"
                                    isSearchable={false}
                                    noOptionsMessage={() => "Select Option..."}
                                    value={getValue()}
                                    onChange={(value) => onChangeSelect(value)}
                                />
                            </div>

                            <div className="col-12 col-md-2">
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={UpdatePrecertButton}
                                >
                                    Update
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <FooterText footerType="black"/>
        </div>
    );
};

export default UpdatePrecert;
